import React from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";

function Question(props) {
    return (
        <div className={props.color ? 'services_question bg_color p-100' : 'services_question p-100'}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="question_title">
                        <div className="example" data-text="FAQs">
                            <h2>Frequently Asked Questions</h2>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="services_faqs">
                        <Accordion defaultActiveKey="0">

                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    How can retailers benefit from retail software?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>Retailers can take advantage from retail software by restructuring inventory management, refining customer engagement, enhancing sales and rebates, increasing data analytics, and offering a greater shopping experience both in-store and online.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    What are the advantages of retail software?
                                </Accordion.Header>
                                <Accordion.Body>
                                    <p>The recompences of retail software include improved operational competence, improved inventory control, data-oriented decision-making, enhanced customer relationships, and the capability to adjust to changing market trends and customer conduct.</p>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Question;